import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { password, username, userPassMap } from '../internal.js'

const credentialTypes = [
  username,
  password,
  'requestor',
  'authorization',
] as const

export type cfwlCredType = (typeof credentialTypes)[number]

// TST-CF also exposes a STMT image, but an account statement is not a shipment
// document and has no equivalent DocumentType, so it is not retrieved.
export const cfwlDocumentTypes = [
  'invoice',
  'proof-of-delivery',
  'signed-bol',
  'weight-and-research-inspection',
] as const satisfies readonly DocumentType[]

export const cfwl: CarrierDef<cfwlCredType> = {
  name: 'TST-CF Express',
  scac: 'cfwl',
  credentialTypes,
  legacyCredMap: [
    ...userPassMap,
    ['requestor', 'apiKey'],
    ['authorization', 'apiPassword'],
  ],
  engineLayers: ['documents', 'rating', 'pickup', 'profinder', 'tracking'],
  documentTypes: cfwlDocumentTypes,
  ltlServices: [
    { id: 'standard', name: 'Standard' },
    {
      id: 'guaranteed_nine_am',
      name: 'Guaranteed by 9AM',
      guaranteed: true,
      guaranteedByTime: '09:00',
    },
    {
      id: 'guaranteed_before_twelve_pm',
      name: 'Guaranteed by Noon',
      guaranteed: true,
      guaranteedByTime: '12:00',
    },
    {
      id: 'guaranteed_five_pm',
      name: 'Guaranteed by 5PM',
      guaranteed: true,
      guaranteedByTime: '17:00',
    },
  ],
}
